import { render, staticRenderFns } from "./LibPricingWidget.vue?vue&type=template&id=929cc5aa&scoped=true&"
import script from "./LibPricingWidget.vue?vue&type=script&lang=js&"
export * from "./LibPricingWidget.vue?vue&type=script&lang=js&"
import style0 from "./LibPricingWidget.vue?vue&type=style&index=0&id=929cc5aa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "929cc5aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/architect/projects/gadzoom/gadzoom-marketing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('929cc5aa')) {
      api.createRecord('929cc5aa', component.options)
    } else {
      api.reload('929cc5aa', component.options)
    }
    module.hot.accept("./LibPricingWidget.vue?vue&type=template&id=929cc5aa&scoped=true&", function () {
      api.rerender('929cc5aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/pricing/LibPricingWidget.vue"
export default component.exports